import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { axiosBeelineRequest } from '@beef/utils';
import { createAction, createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';
var initialState = {
  quantity: 0
};
export var fetchData = createAsyncThunk('cart/fetchQuantity', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var _data$stats;
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return axiosBeelineRequest({
            url: url
          });
        case 2:
          data = _context.sent;
          return _context.abrupt("return", (data === null || data === void 0 ? void 0 : (_data$stats = data.stats) === null || _data$stats === void 0 ? void 0 : _data$stats.quantity) || 0);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());

/**
 * @deprecated
 * Use setCartQuantity
 * Pass a primitive number instead of an object
 */
export var setCartData = createAction('cart/setQuantity', function (cartData) {
  var _cartData$stats;
  return {
    payload: (cartData === null || cartData === void 0 ? void 0 : (_cartData$stats = cartData.stats) === null || _cartData$stats === void 0 ? void 0 : _cartData$stats.quantity) || 0
  };
});
export var setCartQuantity = createAction('cart/setQuantity');
var cartSlice = createSlice({
  name: 'cart',
  initialState: initialState,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addMatcher(isAnyOf(setCartQuantity, fetchData.fulfilled), function (state, _ref2) {
      var payload = _ref2.payload;
      state.quantity = payload;
    });
  }
});
export var cart = cartSlice.reducer;